import { render, staticRenderFns } from "./affiliate-program.vue?vue&type=template&id=37b58bde"
import script from "./affiliate-program.vue?vue&type=script&lang=js"
export * from "./affiliate-program.vue?vue&type=script&lang=js"
import style0 from "./affiliate-program.vue?vue&type=style&index=0&id=37b58bde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports